
















import { VehicleCompanyStoreHelper } from '../../core/mixins';
import { Component, Emit, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import Combobox from '../../core/components/Combobox.vue';
@Component({
    components: {
        Combobox
    }
})
export default class VehicleChooserForCurrentCompany extends Mixins(
    VehicleCompanyStoreHelper
) {
    selectedVehicle: null | string = null;
    selectedVehicleResetValue: boolean = false;
    updateSelectedVehicle(value){
     this.selectedVehicle = value;
    }
    updateResetValue(value){
     this.selectedVehicleResetValue = value;
    } 

    get vehiclesList(){
        let filteredIdsOnLastReport = this.$_getFilteredLastReportVehicles;
        return this.$_getVehiclesFromSelectedCompany.filter(
            vehicle => filteredIdsOnLastReport.includes(Number(vehicle.id))
        ).map(vehicle => vehicle)

         
    }

    @Watch('selectedVehicle', { immediate: true })
    onSelectedVehicleChanged(value){
       this.onSelectedVehicle(value)
    }

    @Emit()
    onSelectedVehicle(value) {}
}
